import { EpimsBaseEntityDto } from './epim-base.dto';

export class PLStakeholderMatrixDto extends EpimsBaseEntityDto{
  PLStakeholderId: string;
  PLStageActivityId: string;
  TemplateId: string;
  SubscriptionUserId: string;
  EstimatedDuration: any;
  StakeholderName: string;
  PipelineLicenceRequestId: string;
  }
